import { Injectable, Inject } from '@angular/core';
import { Observable ,  ReplaySubject } from 'rxjs';
import { PayInfoFilters } from './pay-info-filters.model';
import { FiltersService } from '../../dashboard/filters/filters.service';
import { PayInfoView } from '../pay-info-view.model';
import { filter } from 'rxjs/operators';
import { Util } from '../../../../util';
import { DashboardFilters } from '../../dashboard/filters/dashboard-filters.model';

@Injectable()
export class PayInfoFiltersService {
  private subject: ReplaySubject<PayInfoFilters>;
  private _lastFilters: PayInfoFilters;

  private _suppressUpdate = false;

  constructor(@Inject(FiltersService) private _dashboardFiltersService: FiltersService) {
    this.subject = new ReplaySubject<PayInfoFilters>(1);
    this._dashboardFiltersService.getFilters().pipe(
      filter((filt) => filt.payDate !== Util.MIN_DATE || !this._lastFilters)
    ).subscribe(filters => {
      if (!this._suppressUpdate) {
        if (this._lastFilters) {
          this.updateFilters(this._lastFilters.copy(filters));
        } else {
          this.updateFilters(this.createDefaultFilter(filters));
        }
      }
    });
  }

  updateFilters(filters: PayInfoFilters) {
    this._lastFilters = filters;
    this.subject.next(filters);
  }

  clearFilters() {
    if (this._lastFilters) {
      this._lastFilters.reset();
    }
  }

  getFilters(): Observable<PayInfoFilters> {
    return this.subject.asObservable();
  }

  createDefaultFilter(innerFilters: DashboardFilters): PayInfoFilters {
    return new PayInfoFilters(
      innerFilters,
      innerFilters.payDate,
      PayInfoView.EmployeePays,
      PayInfoFilters.supportedPaymentTypes
    );
  }
}
